
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/error",
      function () {
        return require("private-next-pages/error.page.tsx");
      }
    ]);
  